<template>
  <el-tabs :value="recordAuth ? 'first' : 'second'" type="card" @tab-click="tabChange">
    <el-tab-pane v-if="recordAuth" label="维修登记" name="first">
      <repair-registration-list ref="record"/>
    </el-tab-pane>
    <el-tab-pane v-if="reportAuth" label="检测报告" name="second">
      <repair-registration-report-list ref="report"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

  import RepairRegistrationList from "@/views/maintenanceManage/RepairRegistration/RepairRegistrationList.vue";
  import RepairRegistrationReportList from "@/views/maintenanceManage/RepairRegistration/RepairRegistrationReportList.vue";

  export default {
    name: "RepairRegistrationTabs",
    components: {RepairRegistrationReportList, RepairRegistrationList},
    data() {
      return {
        recordAuth: true,
        reportAuth: true,
      };
    },
    methods: {
      tabChange(tab) {
        if (tab.name === "first") {
          this.$refs.record.getList(1);
        }
        if (tab.name === "second") {
          this.$refs.report.getList(1);
        }
      },
    },
  };
</script>

<style scoped>

</style>
